import React from "react"
import {graphql, useStaticQuery} from "gatsby"


import confStyles from './confidence_view.module.scss'
import ConfPicksNew from "./Game Boxes/confidence_picks_new"


const ConfView = () => { 
    const data = useStaticQuery(graphql`
        query {
            allProjectedSpreadsCsv (
                sort: {
                    fields:[
                        home_probability_nfelo
                    ]
                    order: DESC
                }
            ) {
            nodes {
                game_id
                season
                week
                home_team_name
                away_team_name
                home_team_logo_espn
                away_team_logo_espn
                home_line_close
                home_closing_line_rounded_nfelo
                home_ev
                away_ev
                home_probability_nfelo
            }
            }
        }
    `)

    function GetSortOrder(prop) {
        return function(a, b)  {
            if (Math.abs(a[prop]-.5) < Math.abs(b[prop]-.5)) {
                return;
            } else if (Math.abs(a[prop]-.5) > Math.abs(b[prop]-.5)) {
                return -1;
            } else {
                return 0;
            }
        }
    }

    data.allProjectedSpreadsCsv.nodes.sort(GetSortOrder('home_probability_nfelo')) 

    return (
        <div className={confStyles.conf_wrapper}>
            <ConfPicksNew/>
            <div className={confStyles.content_container}>
                <h3 className={confStyles.content_h3}>
                    NFL Confidence Pool Picks
                </h3>
                <p className={confStyles.content_p}>
                    NFL confidence pools (also known as pick’ems) are season long prediction competitions typically held amongst office colleagues or friend groups. Each week, players pick straight up winners for every game and stack rank those picks based on how confident they are in their prediction. These are your "confidence picks."<br className={confStyles.content_break}/>
                    When a player’s pick is correct, they’re awarded points based on how highly they ranked the game. Their most confident pick yields 16 points, their second most confident pick yields 15 points, and so on and so forth. The player with the most points across all games wins the pool, with prizes typically given for weekly and entire season.
                </p>
                <h3 className={confStyles.content_h3}>
                    Confidence Pool Strategy
                </h3>
                <p className={confStyles.content_p}>
                    Winning an NFL confidence pool requires two essential abilities -- picking games accurately and ranking games effectively. The most accurate picker over the course of an NFL season typically won’t actually win the pool because they did a poor job ranking their selections. Confidence pool players often turn to published picks from confidence pool experts to help inform their selections, but these approaches add a heavy element of subjectivity. The most surefire way to reliably maximize picking accuracy and ranking efficiency is to use a model that tells you both.
                </p>
                <h3 className={confStyles.content_h3}>
                    nfelo’s Free Confidence Pool Picks
                </h3>
                <p className={confStyles.content_p}>
                    nfelo is a power ranking model that incorporates a wide variety of data points and market information from oddsmakers to generate some of the most accurate picks available on the internet. Since 2009, it's picked winners more accurately than the closing point spread in its backtests and repeatedly finishes in the upper decile of 538's pick'em competition.<br className={confStyles.content_break}/>
                    Though the model is designed for spreads, those spreads are easily translated into win probability projections, which are perfect for an NFL confidence pool. Not only does the model predict a winner, its win probability number tells you exactly how confident you should be in each projection. All this work is done for you and presented in the table above.
                </p>
            </div>
        </div>
    )
}

export default ConfView